"use client";

import { ReactNode } from "react";

export default function Layout({ children }: { children: ReactNode }) {
  return <div className="pt-4 container">{children}</div>;
}
